import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

export const isSupabaseConfigured = Boolean(url && anonKey);

// عميل Supabase الوحيد في التطبيق — يُستورد من هنا فقط في كل مكان آخر
export const supabase = isSupabaseConfigured ? createClient(url, anonKey, {
  auth: {
    persistSession: true,   // الجلسة تُدار بالكامل عبر Supabase Auth (كوكيز/تخزين آمن داخلي)، وليس عبر localStorage يدويًا
    autoRefreshToken: true
  }
}) : null;
